import * as React from "react";
import { Notification } from "../Notification";
import { BallSleepingIcon } from "@draftkings/arena-web";
export const NoBetsScreen = React.memo(function NoBetsScreen(props) {
    const { dictionary, onClick } = props;
    return (React.createElement(Notification, { title: dictionary.myBetsDictionary.NoBetsMessageTitle, subtitle: dictionary.myBetsDictionary.NoBetsMessageSubtitle, btnText: dictionary.myBetsDictionary.NoBetsBtnText, onClick: onClick },
        React.createElement(BallSleepingIcon, { variant: "noBets", accessibilityText: props.dictionary.myBetsDictionary.BallSleepingIcon })));
});
//# sourceMappingURL=NoBetsScreen.js.map